import { Component, OnInit, EventEmitter } from '@angular/core';
import * as Materialize from 'angular2-materialize/dist/index';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { AccountAdminService } from './accountadmin.service';
import { S3CredService } from '../shared/s3-cred-service';
import * as globals from '../globals';
import { NavbarService } from '../navbar/navbar.service';


@Component({
  selector: 'app-accountadmin',
  templateUrl: './accountadmin.component.html',
  styleUrls: ['./accountadmin.component.css'],
  providers: [AccountAdminService, S3CredService]
})
export class AccountadminComponent implements OnInit {
  tenantid: string = '';
  planid: string;

  public dateformatsArray: any = [];
  public currenciesArray: any = [];
  public dateformatDict: any = {};
  public currencyformatDict: any = {};

  currenciesNameDict: any = {};
  currenciesSymbolDict: any = {};
  currenciesShort_nameDict: any = {};

  currentDateFormat: number;
  currentCurrencyFormat: number;
  todaysDate: Date;
  dateSelect: number;
  currencySelect: number;
  dateFormat: string;
  tenanturl: string;

  leverActive: boolean;
  quote_auto_sequence_start: number;
  quote_auto_sequence_padding: number;
  quote_contact_info: string;
  quote_document_footer: string;
  logoFile: any;
  private bucketname = globals.BUCKETNAME;
  ImageNotFound: boolean = false;

  logoURL: string;
  uploadInProgress: boolean = false;

  constructor(
    private accountAdminService: AccountAdminService,
    private s3CredService: S3CredService,
    public navService: NavbarService
  ) {}

  ngOnInit() {
    this.navService.show('ACCOUNT SETTINGS');
    this.navService.setNavID(11);

    this.tenantid = localStorage.getItem('mr_tenantid');
    // refactor
    // service to check for enumerated plan types each corresponding to different globals being returned?
    this.planid = localStorage.getItem('mr_planid');
    

    if (this.planid === '3') {
      this.tenanturl = globals.GOVTENANTURL;
    } else {
      this.tenanturl = globals.TENANTURL;
    }
    this.logoURL =
    this.tenanturl+'/' +
    this.bucketname +
    '/' +
    this.tenantid +
    '/logo/logo.jpg'+ '?v=' + Math.random();

    this.getAdminSettings();
  }

  dateHeaderClicked(){
    console.log('date Header Clicked');
    
        if (document.getElementById('dateFormatInfoCollapsibleBody').className != 'active') {
          document.getElementById('dateArrowRight').style.display = 'block';
          document.getElementById('dateArrowDown').style.display = 'none';
    
        } else {
          document.getElementById('dateArrowRight').style.display = 'none';
          document.getElementById('dateArrowDown').style.display = 'block';
        }
  }

  currencyHeaderClicked(){
    console.log('currency Header Clicked');
    
      if (document.getElementById('currencyInfoCollapsibleBody').className != 'active') {
        document.getElementById('currencyArrowRight').style.display = 'block';
        document.getElementById('currencyArrowDown').style.display = 'none';
  
      } else {
        document.getElementById('currencyArrowRight').style.display = 'none';
        document.getElementById('currencyArrowDown').style.display = 'block';
      }
  }

  settingsHeaderClicked(){
    console.log('settings Header Clicked');
    
      if (document.getElementById('settingsInfoCollapsibleBody').className != 'active') {
        document.getElementById('settingsArrowRight').style.display = 'block';
        document.getElementById('settingsArrowDown').style.display = 'none';
  
      } else {
        document.getElementById('settingsArrowRight').style.display = 'none';
        document.getElementById('settingsArrowDown').style.display = 'block';
      }
  }

  ngAfterViewInit() {
  }

  onChangeInLeverSettings(e) {
    let autosequesnceEnabled;
    if (e.target.checked) {
      this.leverActive = true;
      autosequesnceEnabled = 1;
    } else {
      this.leverActive = false;
      autosequesnceEnabled = 0;
    }
    let accountSettings = {
      quote_auto_sequence_enabled: autosequesnceEnabled
    };

    this.accountAdminService.updateAccountSettings(accountSettings).subscribe(
      data => {
        console.log('data updated');
        localStorage.setItem(
          'mr_quote_auto_sequence_enabled',
          autosequesnceEnabled
        );

        if (autosequesnceEnabled) {
          Materialize.toast('Quote Numbering Sequence Enabled', 1000);
        } else {
          Materialize.toast('Quote Numbering Sequence Disabled', 1000);
        }
      },
      error => {}
    );
  }

  editQuoteNumberingRow() {
    (<HTMLInputElement>document.getElementById(
      'quoteNumberingLever'
    )).disabled = true;

    document.getElementById('quote_auto_sequence_start').style.display = 'none';
    document.getElementById('quote_auto_sequence_startEdit').style.display =
      'block';

    document.getElementById('quote_auto_sequence_padding').style.display =
      'none';
    document.getElementById('quote_auto_sequence_paddingEdit').style.display =
      'block';

    document.getElementById('editQuoteNumbring').style.display = 'none';
    document.getElementById('saveQuoteNumbring').style.display = 'block';
    document.getElementById('cancelQuoteNumbring').style.display = 'block';
  }

  saveQuoteNumberingRow() {
    (<HTMLInputElement>document.getElementById(
      'quoteNumberingLever'
    )).disabled = false;

    document.getElementById('quote_auto_sequence_start').style.display =
      'block';
    document.getElementById('quote_auto_sequence_startEdit').style.display =
      'none';
    let sequence_start = (<HTMLInputElement>document.getElementById(
      'quote_auto_sequence_startEdit'
    )).value;

    document.getElementById('quote_auto_sequence_padding').style.display =
      'block';
    document.getElementById('quote_auto_sequence_paddingEdit').style.display =
      'none';
    let sequence_padding = (<HTMLInputElement>document.getElementById(
      'quote_auto_sequence_paddingEdit'
    )).value;

    document.getElementById('editQuoteNumbring').style.display = 'block';
    document.getElementById('saveQuoteNumbring').style.display = 'none';
    document.getElementById('cancelQuoteNumbring').style.display = 'none';

    let accountSettings = {
      quote_auto_sequence_start: sequence_start,
      quote_auto_sequence_padding: sequence_padding
    };

    this.accountAdminService.updateAccountSettings(accountSettings).subscribe(
      data => {
        console.log('Update Account Numbering Settings');
        this.quote_auto_sequence_start = Number(sequence_start);
        this.quote_auto_sequence_padding = Number(sequence_padding);
        localStorage.setItem('mr_quote_auto_sequence_start', sequence_start);
        localStorage.setItem(
          'mr_quote_auto_sequence_padding',
          sequence_padding
        );
        Materialize.toast('Auto QuoteNumber Row Updated');
      },
      error => {
        Materialize.toast('Unable to Update QuoteNumber Row');
      }
    );
  }

  cancelQuoteNumberingRow() {
    (<HTMLInputElement>document.getElementById(
      'quoteNumberingLever'
    )).disabled = false;

    document.getElementById('quote_auto_sequence_start').style.display =
      'block';
    document.getElementById('quote_auto_sequence_startEdit').style.display =
      'none';

    document.getElementById('quote_auto_sequence_padding').style.display =
      'block';
    document.getElementById('quote_auto_sequence_paddingEdit').style.display =
      'none';

    document.getElementById('editQuoteNumbring').style.display = 'block';
    document.getElementById('saveQuoteNumbring').style.display = 'none';
    document.getElementById('cancelQuoteNumbring').style.display = 'none';
  }

  getAdminSettings() {
    this.accountAdminService.getAccountSettings().subscribe(
      data => {
        let result = JSON.parse(data);
        console.log(' Result : ', data);
        this.dateformatsArray = result.dateformats;
        this.currenciesArray = result.currencies;
        this.currentDateFormat = result.settings[0].date_format_id;
        this.currentCurrencyFormat = result.settings[0].currency_id;
        this.leverActive = result.settings[0].quote_auto_sequence_enabled;
        this.quote_auto_sequence_start =
          result.settings[0].quote_auto_sequence_start;
        this.quote_auto_sequence_padding =
          result.settings[0].quote_auto_sequence_padding;

        this.quote_contact_info = result.settings[0].quote_contact_info;
        if (this.quote_contact_info != null) {
          this.quote_contact_info = this.quote_contact_info.replace(/\n/g, "<br/>");
        }

        this.quote_document_footer = result.settings[0].quote_document_footer;
        if (this.quote_document_footer != null) {
          this.quote_document_footer = this.quote_document_footer.replace(/\n/g, "<br/>");
        }
        
        // this.logoURL = this.
        // let url = "http://mr2-tenantdata-dev.s3.amazonaws.com/" + this.bucketname + '/' + this.tenantid + '/quotes/' + this.selectedQuote.id + '/' + this.selectedQuote.quote_number_id + ".pdf";

        // this.leverActive = true;
        console.log('dateformats : ', this.dateformatsArray);

        this.todaysDate = new Date();
        // this.todaysDate = date.toISOString();

        for (let i = 0; i < this.dateformatsArray.length; i++) {
          this.dateformatDict[
            this.dateformatsArray[i].id
          ] = this.dateformatsArray[i].date_format;
        }
        for (let i = 0; i < this.currenciesArray.length; i++) {
          this.currencyformatDict[this.currenciesArray[i].id] =
            this.currenciesArray[i].name +
            ' (' +
            this.currenciesArray[i].short_name +
            ') ' +
            this.currenciesArray[i].symbol;
          this.currenciesNameDict[
            this.currenciesArray[i].id
          ] = this.currenciesArray[i].name;
          this.currenciesSymbolDict[
            this.currenciesArray[i].id
          ] = this.currenciesArray[i].symbol;
          this.currenciesShort_nameDict[
            this.currenciesArray[i].id
          ] = this.currenciesArray[i].short_name;
        }

        this.dateFormat = this.dateformatDict[this.currentDateFormat];
      },
      error => {}
    );
  }

  onImageError() {
    this.ImageNotFound = true;
  }

  fileChanged(event) {
    console.log('File changed : ', event.target.files[0]);
    console.log(event.target.files[0]);
    this.logoFile = event.target.files[0];

    document.getElementById('browseButton').style.display = 'none';
    document.getElementById('uploadButton').style.display = 'block';
    document.getElementById('cancelLogo').style.display = 'block';
    document.getElementById('editLogo').style.display = 'none';
  }

  fileUpload() {
    let locallogoUrl = this.logoURL;
    this.logoURL = '';

    this.uploadInProgress = true;
    (<HTMLInputElement>document.getElementById('uploadButton')).disabled = true;
    (<HTMLInputElement>document.getElementById('browseButton')).disabled = true;
    document.getElementById('uploadingLogo').style.display = 'block';

    // document.getElementById('browseButton').style.display = 'none';
    // document.getElementById('uploadButton').style.display = 'block';
    document.getElementById('cancelLogo').style.display = 'none';
    document.getElementById('editLogo').style.display = 'none';
    // (<HTMLInputElement>document.getElementById('browseButton')).disabled = true;
    let filename = this.logoFile.name;
    this.s3CredService.getLogoS3Creds().subscribe(
      data => {
        let s3credentials = JSON.parse(data);
        let policy = s3credentials.s3creds.s3Policy;
        let signature = s3credentials.s3creds.s3Signature;
        let serverdate = s3credentials.s3creds.serverDate;
        // let breadCrumbStringPath = this._ProjectsInfoService.getCurrentBredcrumbPath();
        console.log('policy:', policy);
        console.log('signature:', signature);
        console.log('serverdate:', serverdate);

        let formData: any = new FormData();
        let xhr = new XMLHttpRequest();

        // let filename = quoteid + '.pdf';

        console.log('inside makeFileRequest');

        let todayYMD = serverdate;
        let todayISO = serverdate + 'T000000Z';

        console.log('=>todayISO:', todayISO);
        console.log('=>todayYMD:', todayYMD);
        console.log('=>signature:', signature);
        console.log('=>policy:', policy);

        console.log(
          '=>key:',
          this.bucketname + '/' + this.tenantid + '/logo/logo.jpg'
        );

        formData.append('acl', 'public-read');
        formData.append('Content-Type', 'application/octet-stream');
        formData.append('X-Amz-Date', todayISO);
        formData.append('x-amz-server-side-encryption', 'AES256');
        formData.append('x-amz-meta-uuid', '14365123651274');
        formData.append('X-Amz-Algorithm', 'AWS4-HMAC-SHA256');

        if (this.planid === '3') {
          formData.append('X-Amz-Credential', 'AKIALRY7TZ3GLH7GMHOQ/' + todayYMD + '/us-gov-west-1/s3/aws4_request');
        } else {
          // LEAVE us-west-2 HARDCODED.  The server has this hardcoded to match, and S3 is region-free...
          formData.append('X-Amz-Credential', 'AKIAIOFP5KTDKSWJUH3Q/' + todayYMD + '/us-west-2/s3/aws4_request');
        }


        formData.append('X-Amz-Signature', signature);
        formData.append('Policy', policy);

        formData.append(
          'key', 
          this.bucketname + '/' + this.tenantid + '/logo/logo.jpg'
        );

        formData.append('file', this.logoFile);

        console.log('Form data appended');

        xhr.onreadystatechange = () => {
          if (xhr.readyState == 4) {
            if (xhr.status == 200) {
              console.log('logo uploaded');
              this.logoURL = locallogoUrl + '?v=' + Math.random();
              this.ImageNotFound = false;
              // resolve(JSON.parse(xhr.response));
              //   this.progresses[0].currentValue = 100;
            } else if (xhr.status == 204) {
              // resolve(true);
              this.logoURL = locallogoUrl + '?v=' + Math.random();
              this.ImageNotFound = false;
              //   this.progresses[0].currentValue = 100;
            } else {
              // reject(xhr.response);
            }
            this.uploadInProgress = false;
            (<HTMLInputElement>document.getElementById(
              'uploadButton'
            )).disabled = false;
            (<HTMLInputElement>document.getElementById(
              'browseButton'
            )).disabled = false;

            document.getElementById('uploadingLogo').style.display = 'none';
            document.getElementById('editLogo').style.display = 'block';

            document.getElementById('uploadButton').style.display = 'none';
            document.getElementById('browseButton').style.display = 'none';
            document.getElementById('logofilename').style.display = 'none';
          }
        };
        // let url = "https://s3-us-gov-west-1.amazonaws.com";
        xhr.open('POST', this.tenanturl, true);
        xhr.send(formData);
      },
      error => {}
    );
  }

  editDateFormat() {
    document.getElementById('dateFormat').style.display = 'none';
    document.getElementById('dateFormatEdit').style.display = 'block';

    document.getElementById('editDateFormat').style.display = 'none';
    document.getElementById('saveDateFormat').style.display = 'block';
    document.getElementById('cancelDateformat').style.display = 'block';
  }

  editlogo() {
    document.getElementById('browseButton').style.display = 'block';
    // (<HTMLInputElement>document.getElementById('browseButton')).disabled = false;
    document.getElementById('logofilename').style.display = 'block';
    document.getElementById('uploadButton').style.display = 'none';
    document.getElementById('cancelLogo').style.display = 'block';
    document.getElementById('editLogo').style.display = 'none';
  }

  cancellogo() {
    document.getElementById('browseButton').style.display = 'none';
    document.getElementById('uploadButton').style.display = 'none';
    document.getElementById('logofilename').style.display = 'none';
    document.getElementById('cancelLogo').style.display = 'none';
    document.getElementById('editLogo').style.display = 'block';
  }

  saveDateFormat() {
    this.currentDateFormat = this.dateSelect;
    this.dateFormat = this.dateformatDict[this.currentDateFormat];

    document.getElementById('dateFormat').style.display = 'block';
    document.getElementById('dateFormatEdit').style.display = 'none';

    document.getElementById('editDateFormat').style.display = 'block';
    document.getElementById('saveDateFormat').style.display = 'none';
    document.getElementById('cancelDateformat').style.display = 'none';

    let accountSettings = {
      date_format_id: this.currentDateFormat
    };

    this.accountAdminService.updateAccountSettings(accountSettings).subscribe(
      data => {
        console.log('data updated');
        localStorage.setItem('mr_date_format_id', this.dateFormat);
      },
      error => {}
    );
  }

  cancelDateFormat() {
    document.getElementById('dateFormat').style.display = 'block';
    document.getElementById('dateFormatEdit').style.display = 'none';

    document.getElementById('editDateFormat').style.display = 'block';
    document.getElementById('saveDateFormat').style.display = 'none';
    document.getElementById('cancelDateformat').style.display = 'none';
  }

  onDateFormatChange(value) {
    console.log('date select value', value);
    this.dateSelect = value;
  }

  editCurrencyFormat() {
    document.getElementById('currencyFormat').style.display = 'none';
    document.getElementById('currencyFormatEdit').style.display = 'block';

    document.getElementById('editCurrency').style.display = 'none';
    document.getElementById('saveCurrency').style.display = 'block';
    document.getElementById('cancelCurrency').style.display = 'block';
  }

  saveCurrencyFormat() {
    this.currentCurrencyFormat = this.currencySelect;

    document.getElementById('currencyFormat').style.display = 'block';
    document.getElementById('currencyFormatEdit').style.display = 'none';

    document.getElementById('editCurrency').style.display = 'block';
    document.getElementById('saveCurrency').style.display = 'none';
    document.getElementById('cancelCurrency').style.display = 'none';

    let accountSettings = {
      currency_id: this.currentCurrencyFormat
    };

    this.accountAdminService.updateAccountSettings(accountSettings).subscribe(
      data => {
        console.log('data updated');
        localStorage.setItem(
          'mr_currency_id',
          this.currenciesShort_nameDict[this.currentCurrencyFormat]
        );
        localStorage.setItem(
          'mr_currency_symbol',
          this.currenciesSymbolDict[this.currentCurrencyFormat]
        );
      },
      error => {}
    );
  }

  cancelCurrencyFormat() {
    document.getElementById('currencyFormat').style.display = 'block';
    document.getElementById('currencyFormatEdit').style.display = 'none';

    document.getElementById('editCurrency').style.display = 'block';
    document.getElementById('saveCurrency').style.display = 'none';
    document.getElementById('cancelCurrency').style.display = 'none';
  }

  onCurrencyFormatChange(value) {
    console.log('currency select value', value);
    this.currencySelect = value;
  }

  editContactInfo() {
    let quote_contact_infolocal = this.quote_contact_info;

    if (quote_contact_infolocal != null) {
      quote_contact_infolocal = quote_contact_infolocal.replace(/<br\s*[\/]?>/gi, "\n");
    }

    (<HTMLInputElement>document.getElementById('contactinfotextarea')).value = quote_contact_infolocal;

    document.getElementById('contactinfo').style.display = 'none';
    document.getElementById('editcontactinfo').style.display = 'block';

    document.getElementById('editCompanyInfo').style.display = 'none';
    document.getElementById('saveCompanyInfo').style.display = 'block';
    document.getElementById('cancelCompanyInfo').style.display = 'block';
  }

  cancelEditContactInfo() {
    document.getElementById('contactinfo').style.display = 'block';
    document.getElementById('editcontactinfo').style.display = 'none';

    document.getElementById('editCompanyInfo').style.display = 'block';
    document.getElementById('saveCompanyInfo').style.display = 'none';
    document.getElementById('cancelCompanyInfo').style.display = 'none';
  }

  saveContactInfo() {

    let comment = (<HTMLInputElement>document.getElementById('contactinfotextarea')).value;

    document.getElementById('contactinfo').style.display = 'block';
    document.getElementById('editcontactinfo').style.display = 'none';

    document.getElementById('editCompanyInfo').style.display = 'block';
    document.getElementById('saveCompanyInfo').style.display = 'none';
    document.getElementById('cancelCompanyInfo').style.display = 'none';

    this.quote_contact_info = comment;
    let accountSettings = {
      quote_contact_info: this.quote_contact_info
    };

    this.accountAdminService.updateAccountSettings(accountSettings).subscribe(
      data => {
        console.log('Account Contact Info updated');
        localStorage.setItem('mr_quote_contact_info', this.quote_contact_info);

        if (this.quote_contact_info != null) {
          this.quote_contact_info = this.quote_contact_info.replace(/\n/g, "<br/>");
        }
      },
      error => {
        console.log('Unable to Update Contact Info.', error);
      }
    );
  }

  editFooter() {
    let quote_document_footerlocal = this.quote_document_footer;

    if (quote_document_footerlocal != null) {
      quote_document_footerlocal = this.quote_document_footer.replace(/<br\s*[\/]?>/gi, "\n");
    }

    (<HTMLInputElement>document.getElementById('footertextarea')).value = quote_document_footerlocal;
    document.getElementById('editfooter').style.display = 'block';
    document.getElementById('footer').style.display = 'none';

    document.getElementById('editQuoteFooter').style.display = 'none';
    document.getElementById('saveQuoteFooter').style.display = 'block';
    document.getElementById('cancelQuoteFooter').style.display = 'block';
  }
  cancelEditFooter() {
    document.getElementById('editfooter').style.display = 'none';
    document.getElementById('footer').style.display = 'block';

    document.getElementById('editQuoteFooter').style.display = 'block';
    document.getElementById('saveQuoteFooter').style.display = 'none';
    document.getElementById('cancelQuoteFooter').style.display = 'none';
  }
  saveFooter() {

      let comment =  (<HTMLInputElement>document.getElementById('footertextarea')).value
    document.getElementById('editfooter').style.display = 'none';
    document.getElementById('footer').style.display = 'block';

    document.getElementById('editQuoteFooter').style.display = 'block';
    document.getElementById('saveQuoteFooter').style.display = 'none';
    document.getElementById('cancelQuoteFooter').style.display = 'none';

    this.quote_document_footer = comment;
    let accountSettings = {
      quote_document_footer: this.quote_document_footer
    };

    this.accountAdminService.updateAccountSettings(accountSettings).subscribe(
      data => {
        console.log('Account Contact Info updated');
        localStorage.setItem('mr_quote_document_footer', this.quote_document_footer);

        if (this.quote_document_footer != null) {
          this.quote_document_footer = this.quote_document_footer.replace(/\n/g, "<br/>");
        }
      },
      error => {
        console.log('Unable to Update Contact Info.', error);
      }
    );
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/accountadmin/accountadmin.component.ts